window.SkillsManager = Component.extend({

    initialize: function(ids) {
        this.name = "SkillsManager";
        this.skills = new Skills();
    },

    reset: function() {
        this.skills = new Skills();
    },

    setup: function(container) {
        this.container = container;
        this.storage = container.storage;
    },

    addSkill: function(skill) {
        this.skills.add(skill, {merge: true});
		this.save();
    },

    removeSkill: function(id) {
		this.skills.remove(id);
		this.save();
	},

    getSkill: function(pageId) {
        return this.skills.get(pageId);
    },

	getSkills: function(filter) {
		return this.skills.where(filter);
	},

    getPinnedSkills: function() {
        // do we include skills with notes?
        return this.skills.where({isPinned: true});
    },

    save: function() {
        this.storage.setItem(this.name, this.skills, true);
    },

    load: function() {
        var skills = this.storage.getItem(this.name);
        if(skills === -1) return;

        this.skills = new Skills(skills);
    },
}, {
    MAX_NOTES_LENGTH: 100
});
// module.exports.SkillsManager = SkillsManager;

window.Skill = Backbone.Model.extend(
{
	idAttribute: "pageId",

	defaults: {
        pageId: undefined,
        skillId: undefined, // added later for translations
		category: undefined,
		rating: undefined,
        title: undefined,
        notes: "",
        isPinned: false
	},

    getPageId: function() {
		return this.get("pageId");
	},

    getSkillId: function() {
		return this.get("skillId");
	},

	getCategory: function() {
		return this.get("category");
	},

	getRating: function() {
		return this.get("rating");
	},

    getTitle: function() {
		return this.get("title");
	},

    getNotes: function() {
		return this.get("notes");
	},

    isPinned: function() {
		return this.get("isPinned");
	},

    setPageId: function(pageId) {
		return this.set("pageId", pageId);
	},

    setSkillId: function(skillId) {
		return this.set("skillId", skillId);
	},

    setCategory: function(category) {
		return this.set("category", category);
	},

	setRating: function(rating) {
		return this.set("rating", rating);
	},

	setNotes: function(notes) {
		return this.set("notes", notes);
	},

	setPinned: function(isPinned) {
		return this.set("isPinned", isPinned);
	}
});
// module.exports.Skill = Skill;

window.Skills = Backbone.Collection.extend(
{
	model: Skill
});
// module.exports.Skills = Skills;
